import React from 'react';
import t from 'react-translate';
import { LearnerProgressFilters } from './filters-flyout-modal';

export const buildFilterDescription = (filters: LearnerProgressFilters): React.ReactNode[] => {
  const parts: React.ReactNode[] = [];
  if (filters.assignmentsEnabled && filters.assignmentName) {
    parts.push(
      <span key='assignment'>
        {t.LEARNER_PROGRESS.FILTERS.HAS_NOT_COMPLETED_PREFIX()} <strong>{filters.assignmentName}</strong>
      </span>,
    );
  }
  if (filters.inactiveForEnabled && filters.inactiveFor) {
    const hasAssignment = filters.assignmentsEnabled && filters.assignmentName;
    parts.push(
      <span key='inactive'>
        {hasAssignment
          ? t.LEARNER_PROGRESS.FILTERS.INACTIVE_DETAIL(filters.inactiveFor.toString())
          : t.LEARNER_PROGRESS.FILTERS.INACTIVE_DETAIL_STANDALONE(filters.inactiveFor.toString())}
      </span>,
    );
  }
  if (filters.minPointsEnabled && filters.minPoints) {
    const hasPrevious = parts.length > 0;
    parts.push(
      <span key='min-points'>
        {hasPrevious
          ? t.LEARNER_PROGRESS.FILTERS.EARNED_FEWER_DETAIL(filters.minPoints.toString())
          : t.LEARNER_PROGRESS.FILTERS.EARNED_FEWER_DETAIL_STANDALONE(filters.minPoints.toString())}
      </span>,
    );
  }
  return parts;
};

// Matches the TWO / THREE_OR_FOUR / MANY categories `i18nJoin` (shared/services/i18n-utils.ts)
// already uses elsewhere, so 3+ active filters read as "A, B, and C" rather than "A and B and C".
const getLengthCategory = (count: number): 'TWO' | 'THREE_OR_FOUR' | 'MANY' => {
  if (count <= 2) return 'TWO';
  if (count <= 4) return 'THREE_OR_FOUR';
  return 'MANY';
};

export const joinFilterDescriptionParts = (parts: React.ReactNode[]): React.ReactNode[] => {
  const lengthCategory = getLengthCategory(parts.length);

  return parts.reduce<React.ReactNode[]>((acc, part, i, arr) => {
    acc.push(part);
    if (i === arr.length - 1) return acc;
    if (i === arr.length - 2) {
      acc.push(t.JOIN[lengthCategory].AND());
    } else if (lengthCategory !== 'TWO') {
      // Only reachable with 3+ parts, where lengthCategory is never 'TWO'.
      acc.push(t.JOIN[lengthCategory].COMMA());
    }
    return acc;
  }, []);
};
